import React from 'react';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {ColumnGroup} from 'primereact/columngroup';
import {Row} from 'primereact/row';

export default function ProductionDataTable({items = [], loading = false, renderStatus, showSchedule = false, emptyMessage}) {
  const {t, i18n} = useTranslation('common');
  const number = (value, maximumFractionDigits = 2) => value == null ? '—' : new Intl.NumberFormat(i18n.language, {maximumFractionDigits}).format(value);
  const money = (value, row) => value == null ? '—' : `${number(value, row.currency === 'HUF' ? 0 : 2)} ${row.currency_symbol || row.currency || ''}`;
  const columns = [
    ...(showSchedule ? [['scheduled_from', 'capacityDate'], ['shift_name', 'capacityShift'], ['time_range', 'capacityTimeRange']] : []),
    ['machine', 'shiftMachine'], ['employee', 'shiftEmployee'], ['partner', 'shiftCustomer'],
    ['project_number', 'shiftProjectNumber'], ['drawing_number', 'shiftDrawingNumber'],
    ['net_amount', 'shiftNetAmount'], ['standard_minutes', 'shiftStandardTime'],
    ['operation', 'shiftOperation'], ['status', 'shiftStatus'],
  ];
  const headers = <ColumnGroup><Row>
    {columns.map(([field, label]) => <Column key={field} header={t(label)} rowSpan={2}/>)}
    <Column header={t('shiftProductionTimes')} colSpan={2}/>
  </Row><Row><Column header={t('shiftMainTime')}/><Column header={t('shiftAuxiliaryTime')}/></Row></ColumnGroup>;
  return <DataTable value={items} dataKey="id" loading={loading} headerColumnGroup={headers}
    className="p-datatable-sm" stripedRows emptyMessage={emptyMessage || t('capacityNoTasks')} responsiveLayout="scroll">
    {columns.map(([field]) => <Column key={field} field={field} body={row => {
      if (field === 'net_amount') return <span style={{whiteSpace: 'nowrap'}}>{money(row.net_amount, row)} <span>({money(row.project_item_net_amount, row)})</span></span>;
      if (field === 'standard_minutes') return number(row[field]);
      if (field === 'status') return renderStatus ? renderStatus(row.status) : t(`productionStatus.${row.status}`, {defaultValue: row.status || '—'});
      if (field === 'scheduled_from') return row.scheduled_from ? moment(row.scheduled_from).format('YYYY.MM.DD.') : '—';
      if (field === 'time_range') return row.scheduled_from && row.scheduled_until ? `${moment(row.scheduled_from).format('HH:mm')} – ${moment(row.scheduled_until).format('HH:mm')}${moment(row.scheduled_until).isAfter(moment(row.scheduled_from), 'day') ? ' (+1)' : ''}` : '—';
      return row[field] ?? '—';
    }} style={['net_amount', 'standard_minutes'].includes(field) ? {textAlign: 'right'} : undefined}/>)}
    <Column field="main_minutes" body={row => number(row.main_minutes)} style={{textAlign: 'right'}}/>
    <Column field="auxiliary_minutes" body={row => number(row.auxiliary_minutes)} style={{textAlign: 'right'}}/>
  </DataTable>;
}
